import { Box, Tag } from '@nimbus-ds/components';
import { Page } from '@nimbus-ds/patterns';
import {
  InformationForContentDeclarationResponseDto,
  InformationForDocumentResponseDto,
} from '@tiendanube/common';
import useNuvemEnvioTranslations from 'domains/NuvemEnvioCommons/hooks/useNuvemEnvioTranslations/useNuvemEnvioTranslations';

interface PrintLabelHeaderProps {
  information:
    | InformationForContentDeclarationResponseDto[]
    | InformationForDocumentResponseDto[]
    | undefined;
}

function PrintLabelHeader({ information }: Readonly<PrintLabelHeaderProps>) {
  const t = useNuvemEnvioTranslations();

  return (
    <Page.Header
      id="NuvemEnvioAsyncLabelGenerateStatusPageHeader"
      title={t('printNuvemEnvioLabelsStatus.asyncPage.title')}
    >
      <Box display="flex" gap="2">
        {information?.length ? (
          information?.map(
            (
              info:
                | InformationForContentDeclarationResponseDto
                | InformationForDocumentResponseDto,
            ) => <Tag key={info.order?.id}>#{info.order?.number}</Tag>,
          )
        ) : (
          <Tag.Skeleton width="55px" height="20px" />
        )}
      </Box>
    </Page.Header>
  );
}

export default PrintLabelHeader;
